import React, { useState, useEffect } from "react";
import { MobileStepper, Stepper, Step, StepLabel } from "@mui/material";
import { useStep } from "../Form";


export default function FormStepper({steps}){
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Example threshold for mobile screen width
    const { currentStep, incrementStep, decrementStep, isLastStep } = useStep();

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Update when the window is resized
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize); // Cleanup the event listener on unmount
      };
    }, []);

    if(isMobile){
        return(
            <MobileStepper
               variant="dots"
               steps={steps.length}
               position="static"
               activeStep={currentStep}
               sx={{ justifyContent: 'center', padding: 2 }} />)
   
    }
    else{
        return(
            <Stepper activeStep={currentStep} alternativeLabel={true} sx={{ pt: 3, pb: 5 }}>
            {steps.map((step, index) => (
            <Step key={index}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
          </Stepper>
        )
    }

}